import React, { ReactNode } from 'react'
import { LedgerIcon, RupeeCircleIcon, StatementIcon, CogIcon } from '@okcredit/web-lib'
import ReconciledIcon from 'assets/icons/icon-file-tree.svg'
import NamasteIcon from 'assets/icons/help_namaste.svg'
import MyPlanIcon from 'assets/icons/my_plan_subscription.svg'
import { IconDoneCircle, IconReceiptWithBeta, IconStats, IconTruck } from 'assets/icons'
import { newPaths } from 'routes'
import { THEME } from 'components/theme'

export type TABS = {
  icon: ReactNode
  title: string
  routeName: string
}[]

export type ScreenName =
  | 'ledger'
  | 'myPlan'
  | 'stats'
  | 'approve'
  | 'supply'
  | 'collection'
  | 'summary'
  | 'reconcile'
  | 'billing'
  | 'help'
  | 'settings'
export const SCREEN_NAME: Record<ScreenName, string> = {
  ledger: 'Ledger',
  myPlan: 'My Plan',
  stats: 'Stats',
  approve: 'Approve',
  supply: 'Supply',
  collection: 'Collection',
  summary: 'Summary',
  reconcile: 'Reconcile',
  billing: 'Billing',
  help: 'Help',
  settings: 'Settings'
}

export const ledgerTabItem = {
  icon: <LedgerIcon size={24} />,
  title: SCREEN_NAME.ledger,
  routeName: newPaths.ledger
}
export const TabsDetails: Record<
  string,
  {
    icon: React.JSX.Element
    title: string
    routeName: string
  }
> = {
  [SCREEN_NAME.ledger]: ledgerTabItem,
  [SCREEN_NAME.myPlan]: {
    icon: <img src={MyPlanIcon} height={24} width={24} alt="My Plan" />,
    title: SCREEN_NAME.myPlan,
    routeName: newPaths.myPlan
  },
  [SCREEN_NAME.stats]: {
    icon: <img src={IconStats} height={24} width={24} />,
    title: 'Stats',
    routeName: newPaths.brand
  },
  [SCREEN_NAME.approve]: {
    icon: <img src={IconDoneCircle} height={24} width={24} />,
    title: SCREEN_NAME.approve,
    routeName: newPaths.approve
  },
  [SCREEN_NAME.supply]: {
    icon: <img src={IconTruck} height={24} width={24} />,
    title: SCREEN_NAME.supply,
    routeName: newPaths.supplyList
  },
  [SCREEN_NAME.collection]: {
    // "1-Click Vasooli" — bulk WhatsApp reminder campaigns (was the unused
    // StaffLink collection-list tab; repointed to the vasooli Collection page)
    icon: <RupeeCircleIcon size={24} />,
    title: SCREEN_NAME.collection,
    routeName: newPaths.collection
  },
  [SCREEN_NAME.summary]: {
    icon: <StatementIcon fill="black" size={24} />,
    title: SCREEN_NAME.summary,
    routeName: newPaths.summary
  },
  [SCREEN_NAME.reconcile]: {
    icon: <img src={ReconciledIcon} height={24} width={24} />,
    title: SCREEN_NAME.reconcile,
    routeName: newPaths.reconcile
  },
  [SCREEN_NAME.billing]: {
    icon: <img src={IconReceiptWithBeta} height={38} width={38} style={{ paddingTop: 18 }} />,
    title: SCREEN_NAME.billing,
    routeName: newPaths.billing
  },
  [SCREEN_NAME.help]: {
    icon: <img src={NamasteIcon} height={24} width={24} alt="Help" />,
    title: SCREEN_NAME.help,
    routeName: newPaths.help
  },
  [SCREEN_NAME.settings]: {
    icon: <CogIcon size={24} fill={THEME.brandBlack} />,
    title: SCREEN_NAME.settings,
    routeName: newPaths.settings
  }
}
